import Swiper, { Mousewheel } from 'swiper';

Swiper.use([Mousewheel]);

const events = window.PointerEvent ? {
    up: 'pointerup',
    enter: 'pointerenter',
    leave: 'pointerleave',
} : {
    up: 'touchend',
    enter: 'mouseenter',
    leave: 'mouseleave',
};

const init = () => {
    const gallery = document.querySelector('.js-gallery');
    if (!gallery) return;

    const galleryThumbs = [...document.querySelectorAll('.js-gallery-thumb')];

    const swiper = new Swiper(gallery, {
        grabCursor: true,
        mousewheel: {
            forceToAxis: true,
        },
        autoHeight: true,
        on: {
            slideChange: (self) => {
                galleryThumbs.forEach((galleryThumb) => {
                    galleryThumb.classList.add('border-white');
                    galleryThumb.classList.remove('border-orange');
                });
                galleryThumbs[self.activeIndex].classList.remove('border-white');
                galleryThumbs[self.activeIndex].classList.add('border-orange');
            },
        },
    });

    galleryThumbs.forEach((galleryThumb, index) => {
        galleryThumb.addEventListener(events.up, () => {
            swiper.slideTo(index);
        });
    });
};

export default init;
